export const MODALS_TYPE = {
  ADMIN_ACCESS_REQUIRED: 'ADMIN_ACCESS_REQUIRED',
  CREATE_CHATBOT: 'CREATE_CHATBOT',
  CONFIRM_DELETE_CHATBOT: 'CONFIRM_DELETE_CHATBOT',
  INVITE_USER_MODAL: 'INVITE_USER_MODAL',
  CONNECT_PAGES_MODAL: 'CONNECT_PAGES_MODAL',
  DEACTIVATE_AFFILIATE_MODAL: 'DEACTIVATE_AFFILIATE_MODAL',
  DISCONNECT_PAGES_MODAL: 'DISCONNECT_PAGES_MODAL',
  DIALOGUE_SETTINGS_MODAL: 'DIALOGUE_SETTINGS_MODAL',
  UNIVERSAL_UPGRADE_LANDMINE: 'UNIVERSAL_UPGRADE_LANDMINE',
  REMOVE_USER_MODAL: 'REMOVE_USER_MODAL',
  MENU_BUTTON_CONFIG_FORM: 'MENU_BUTTON_CONFIG_FORM',
  ADD_EMAIL_MODAL: 'ADD_EMAIL_MODAL',
  TEST_CONNECTION_MODAL: 'TEST_CONNECTION_MODAL',
  BUTTON_CONFIG_FORM: 'BUTTON_CONFIG_FORM',
  CONNECTED_PAGE_ERROR_MODAL: 'CONNECTED_PAGE_ERROR_MODAL',
  IMAGE_UPLOAD_FORM_MODAL: 'IMAGE_UPLOAD_FORM_MODAL',
  GET_STARTED_ONBOARDING_MODAL: 'GET_STARTED_ONBOARDING_MODAL',
  REFRESH_ACCESS_TOKEN_ERROR_MODAL: 'REFRESH_ACCESS_TOKEN_ERROR_MODAL',
  ADD_PROMOTER_MODAL: 'ADD_PROMOTER_MODAL',
  CREATE_COMPANY_MODAL: 'CREATE_COMPANY_MODAL',
  CREATE_CHAT_BLAST_MODAL: 'CREATE_CHAT_BLAST_MODAL',
  FACEBOOK_ERRORS_MODAL: 'FACEBOOK_ERRORS_MODAL',
  CONTACTS_EXPORT_MODAL: 'CONTACTS_EXPORT_MODAL',
  CONFIRM_CHANGE_BOT_STATUS_MODAL: 'CONFIRM_CHANGE_BOT_STATUS_MODAL',
  OPEN_VARIABLE_FILTER_MODAL: 'OPEN_VARIABLE_FILTER_MODAL',
  OPEN_REACHABLE_FILTER_MODAL: 'OPEN_REACHABLE_FILTER_MODAL',
  OPEN_PLATFORMS_FILTER_MODAL: 'OPEN_PLATFORMS_FILTER_MODAL',
  DOWNGRADE_FACEBOOK_PAGE_MODAL: 'DOWNGRADE_FACEBOOK_PAGE_MODAL',
  NO_LINKED_AD_ACCOUNT_MODAL: 'NO_LINKED_AD_ACCOUNT_MODAL',
  CUSTOM_AUDIENCE_ERROR_MODAL: 'CUSTOM_AUDIENCE_ERROR_MODAL',
  GENERAL_TEXT_MODAL: 'GENERAL_TEXT_MODAL',
  CONFIRM_DOWNGRADE_PROMO_MODAL: 'CONFIRM_DOWNGRADE_PROMO_MODAL',
  SHARE_BOT_MODAL: 'SHARE_BOT_MODAL',
  ACTIVATE_INACTIVE_BOT_MODAL: 'ACTIVATE_INACTIVE_BOT_MODAL',
  ACTIVATE_CHANNELS_MODAL: 'ACTIVATE_CHANNELS_MODAL',
  CONFIRM_FB_DOWNGRADE_MODAL: 'CONFIRM_FB_DOWNGRADE_MODAL',
  CONFIRM_SEND_WELCOME_MESSAGE_MODAL: 'CONFIRM_SEND_WELCOME_MESSAGE_MODAL',
  GENERAL_CONFIRM_MODAL: 'GENERAL_CONFIRM_MODAL',
  LINK_AD_ACCOUNT_MODAL: 'LINK_AD_ACCOUNT_MODAL',
  CONFIRM_DELETE_MODAL: 'CONFIRM_DELETE_MODAL',
  PROMO_BLASTER_MODAL: 'PROMO_BLASTER_MODAL',
  GRANT_PERMISSIONS_MODAL: 'GRANT_PERMISSIONS_MODAL',
  PRETTY_ERROR_MODAL: 'PRETTY_ERROR_MODAL',
  CHATBOT_LIMIT_MODAL: 'CHATBOT_LIMIT_MODAL',
  BILLING_MODAL: 'BILLING_MODAL',
  FREE_TRIAL_UPGRADE_MODAL: 'FREE_TRIAL_UPGRADE_MODAL',
  FEATURE_ACTIVATION_CONGRATS_MODAL: 'FEATURE_ACTIVATION_CONGRATS_MODAL',
  MONTHLY_SENDS_WARNING_MODAL: 'MONTHLY_SENDS_WARNING_MODAL',
  CAMPAIGN_EXCEEDS_SEND_LIMIT_MODAL: 'CAMPAIGN_EXCEEDS_SEND_LIMIT_MODAL',
  SELECT_TEAM_PAGES_MODAL: 'SELECT_TEAM_PAGES_MODAL',
  ADD_MORE_PAGES_TEAM_MODAL: 'ADD_MORE_PAGES_TEAM_MODAL',
  MANAGE_PAGES_MODAL: 'MANAGE_PAGES_MODAL',
  CONFIRM_MANAGE_PAGES_MODAL: 'CONFIRM_MANAGE_PAGES_MODAL',
  CONFIRM_SWAP_PAGES_MODAL: 'CONFIRM_SWAP_PAGES_MODAL',
  ALL_SET_MODAL: 'ALL_SET_MODAL',
  MOBIBLE_DOWNLOAD: 'MOBIBLE_DOWNLOAD',
  MOBILE_DOWNLOAD_CONVERSATION: 'MOBILE_DOWNLOAD_CONVERSATION',
  DIALOGUE_PICKER_MODAL: 'DIALOGUE_PICKER_MODAL',
  DIALOGUE_PICKER_NEW_MODAL: 'DIALOGUE_PICKER_MODAL_NEW',
  IMPORT_CONTACT_LIST_MODAL: 'IMPORT_CONTACT_LIST_MODAL',
  OFFERING_FREE_CONSULTATION_MODAL: 'OFFERING_FREE_CONSULTATION_MODAL',
  BOT_RESPONSE_SETTINGS_MODAL: 'BOT_RESPONSE_SETTINGS_MODAL',
  CHAT_WIDGET_PREVIEW_MODAL: 'CHAT_WIDGET_PREVIEW_MODAL',
  WELCOME_NEW_UI_MODAL: 'WELCOME_NEW_UI_MODAL',
  OPEN_EXPORT_MODAL: 'OPEN_EXPORT_MODAL',
  OPEN_INSTAGRAM_CONNECT_MODAL: 'OPEN_INSTAGRAM_CONNECT_MODAL',
  PERMISSIONS_HELPER_MODAL: 'PERMISSIONS_HELPER_MODAL',
  AUDIENCES_SYNC_RESTRICTIONS_MODAL: 'AUDIENCES_SYNC_RESTRICTIONS_MODAL',
  CONNECT_PAGES_FOLLOW_UP_MODAL: 'CONNECT_PAGES_FOLLOW_UP_MODAL',
  DEC_2020_FB_API_EUROPE_CHANGES_MODAL: 'DEC_2020_FB_API_EUROPE_CHANGES_MODAL',
  EMAIL_SUBMISSION_MODAL: 'EMAIL_SUBMISSION_MODAL',
  SPREADSHEET_TEST_CONNECTION_MODAL: 'SPREADSHEET_TEST_CONNECTION_MODAL',
  CONFIRM_STORY_MENTION_MODAL: 'CONFIRM_STORY_MENTION_MODAL',
  INSTAGRAM_MEDIA_MODAL: 'INSTAGRAM_MEDIA_MODAL',
  MAILCHIMP_TEST_CONNECTION_MODAL: 'MAILCHIMP_TEST_CONNECTION_MODAL',
  SUBSCRIPTION_PAUSING_MODAL: 'SUBSCRIPTION_PAUSING_MODAL',
  MIGRATE_TO_INSTACHAMP_THANKS_MODAL: 'MIGRATE_TO_INSTACHAMP_THANKS_MODAL',
  NEW_AUDIENCE_NAME_PROMPT_MODAL: 'NEW_AUDIENCE_NAME_PROMPT_MODAL',
  OPEN_ACTIVATE_SMS_NUMBER_MODAL: 'OPEN_ACTIVATE_SMS_NUMBER_MODAL',
  QUICK_QUESTION_OPT_IN_MODAL: 'QUICK_QUESTION_OPT_IN_MODAL',
  SELECT_FACEBOOK_PAGE_MODAL: 'SELECT_FACEBOOK_PAGE_MODAL',
  AUDIENCE_EXTRACTOR_MODAL: 'AUDIENCE_EXTRACTOR_MODAL',
  SEND_TEST_EMAIL_MODAL: 'SEND_TEST_EMAIL_MODAL',
  CONNECT_CHANNEL_MODAL: 'CONNECT_CHANNEL_MODAL',
  ACTIVATE_EMAIL_ACCOUNT_MODAL: 'ACTIVATE_EMAIL_ACCOUNT_MODAL',
  EMAIL_ACCOUNT_EDITOR_MODAL: 'EMAIL_ACCOUNT_EDITOR_MODAL',
  SUBSCRIBE_AFTER_FREE_TRIAL_PROMO: 'SUBSCRIBE_AFTER_FREE_TRIAL_PROMO',
  VERIFY_EMAIL_MODAL: 'VERIFY_EMAIL_MODAL',
  CLONE_AUTOMATION: 'CLONE_AUTOMATION',
  IMPORT_AUTOMATION: 'IMPORT_AUTOMATION',
  GOOGLE_SPREADSHEET_MODAL: 'GOOGLE_SPREADSHEET_MODAL',
  INCREASE_EMAIL_LIMIT: 'INCREASE_EMAIL_LIMIT',
  NEW_CONFIRM_MODAL: 'NEW_CONFIRM_MODAL',
  ADD_AUDIENCE_TO_AUTOMATION: 'ADD_AUDIENCE_TO_AUTOMATION',
  CONVERT_LEADS_TO_CONTACTS: 'CONVERT_LEADS_TO_CONTACTS',
  CONVERTED_LEADS_SUCCCESS_MODAL: 'CONVERTED_LEADS_SUCCCESS_MODAL',
  CONTACT_SALES: 'CONTACT_SALES',
  NEW_BILLING_MODAL_2023: 'NEW_BILLING_MODAL_2023',
  EDIT_WEBSITE_URL: 'EDIT_WEBSITE_URL',
  SIGN_UP_X_RAY_MODAL: 'SIGN_UP_X_RAY_MODAL',
  ANALYZE_WEBSITE_TRAFFIC_MODAL: 'ANALYZE_WEBSITE_TRAFFIC_MODAL',
  PROMOTE_INSTACHAMP_MODAL: 'PROMOTE_INSTACHAMP_MODAL',
  CLARIFY_WEBSITE_TRAFFIC_MODAL: 'CLARIFY_WEBSITE_TRAFFIC_MODAL',
  CREATE_MY_LEADS_AUDIENCE_MODAL: 'CREATE_MY_LEADS_AUDIENCE_MODAL',
  CONGRATULATION_ON_FREE_CREDITS_MODAL: 'CONGRATULATION_ON_FREE_CREDITS_MODAL',
  WELCOME_SERIES_MODAL: 'WELCOME_SERIES_MODAL',
  INVOICES_MODAL: 'INVOICES_MODAL',
  EDIT_USER_MODAL: 'EDIT_USER_MODAL',
  BILLING_PRICE_TABLE_MODAL: 'BILLING_PRICE_TABLE_MODAL',
  NEW_INFO_MODAL: 'NEW_INFO_MODAL',
  BILLING_LIMITS_MODAL: 'BILLING_LIMITS_MODAL',
  CONNECT_SENDGRID_MODAL: 'CONNECT_SENDGRID_MODAL',
  ACCOUNT_IS_LOCKED_MODAL: 'ACCOUNT_IS_LOCKED_MODAL',
  SELECT_XRAY_MODAL: 'SELECT_XRAY_MODAL',
  INTEGRATION_MAPPING_MODAL: 'INTEGRATION_MAPPING_MODAL',
};
